import { toast } from 'react-toastify';

const showSuccessNotification = (message: any) => {
    if (typeof message === 'object') toast.success(message.message);
    else if (typeof message === 'string') toast.success(message);
    else toast.warning('Something went wrong with the message');
};

const showErrorNotification = (error: string) => {
    toast.error(error);
};

export { showSuccessNotification, showErrorNotification };
